import {orderBy} from '@/utils'
export const mutations = {
  SET_MAIN_INDICATORS: (state, data) => {
    state.mainIndicators = orderBy(data,'quarter');
  },
};